import { gql } from 'apollo-boost'

const SCRAPING_TEST_CASE_COUNTS_WITH_TAGS = gql`
  query scrapingTestCaseCountsWithTagIds($tagIds: [ID!]!) {
    scrapingTestCaseCountsWithTagIds(tagIds: $tagIds)
  }
`

export default SCRAPING_TEST_CASE_COUNTS_WITH_TAGS
